// extracted by mini-css-extract-plugin
module.exports = {"headerSearch":"SearchBarHeader_headerSearch__XBVs8","hideDesktop":"SearchBarHeader_hideDesktop__taUI7","hideMobile":"SearchBarHeader_hideMobile__nDdKP"};